import { combineReducers } from 'redux';
import fetchUserResponse from './fetchUserReducers';
import checkUser from './checkUserRegisterReducer';

export default combineReducers({
    fetchUserResponse,
    checkUser
 });